export const DBConfig = {
  name: "Paker",
  version: 1,
  objectStoresMeta: [
    {
      store: "notes",
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "name", keypath: "name", options: { unique: false } },
        { name: "list", keypath: "list", options: { unique: false } },
        {
          name: "dateTime",
          keypath: "dateTime",
          options: { unique: false },
        },
      ],
    },
  ],
};
